import { mixins } from 'vue-class-component';
import { Component, Prop } from 'vue-property-decorator';
import FieldWrapper from '../field-wrapper/field-wrapper.vue';
import AbstractField from '../abstract-field/abstract-field';
import PostDetails from '@cms/components/details/post-details/post-details.vue';

@Component({
  name: 'bpc-terms-checkbox',
  components: {
    'bpc-field-wrapper': FieldWrapper,
    'bpc-post-details': PostDetails,
  },
})
export default class TermsCheckbox extends mixins(AbstractField) {
  @Prop({ type: [Boolean, String, Number] }) readonly value: boolean | string | 1 | 0;
  @Prop(String) readonly field: string;

  selectedPostId: number = null;

  get model(): boolean {
    // we ensure with this to return always a boolean true or false
    if (this.value === 'false' || this.value === '0') {
      return false;
    }
    return !!this.value;
  }

  set model(value: boolean) {
    this.$emit('input', value);
    if (this.eventsConfig && this.eventsConfig.emit) {
      this.eventsConfig.emit.forEach(event => {
        this.$root.$emit(event, value);
      });
    }
  }

  get postId(): number {
    if (this.field && this.$store.getters['centerSettings/centerSettings']) {
      return this.$store.getters['centerSettings/centerSettings'][this.field] || false;
    }
  }

  get privacyPolicyPostId(): number {
    if (this.field && this.$store.getters['centerSettings/centerSettings']) {
      return (
        this.$store.getters['centerSettings/centerSettings']['privacy_policy_post_id'] || false
      );
    }
  }
  get interiorRegulationsPostId(): number {
    if (this.field && this.$store.getters['centerSettings/centerSettings']) {
      return (
        this.$store.getters['centerSettings/centerSettings']['interior_regulations_post_id'] ||
        false
      );
    }
  }
  get termsOfSalePostId(): number {
    if (this.field && this.$store.getters['centerSettings/centerSettings']) {
      return this.$store.getters['centerSettings/centerSettings']['terms_of_sale_post_id'] || false;
    }
  }
  get tenantType(): string {
    return this.$store.getters['centerSettings/centerSettings']['center_type'] || 'center';
  }

  selectPostId(id): void {
    this.selectedPostId = id;
  }

  mounted(): void {
    // this.model = this.value;
    console.log('checkboxWrapperAttributes', this.wrapperAttributes);
  }

  // @Watch('model')
  // onModelChanged(val: string) {
  //   this.$emit('input', val);
  // }
}
